import { getWbAssetUrl, selectFields } from '#src/lib/contentful/selectors.mjs';

import styles from './CardImage.scss';

export function CardImage({ image }) {
  const { file: { url } = {} } = selectFields(image) || {};
  const src = getWbAssetUrl(url);
  return !url ? null : <img src={src} className={styles.cardImage} />;
}
